export default interface IPerformanceLogger {
    trace<T>(traceName: string, action: () => Promise<T>): Promise<T>;
};

export const IPerformanceLogger_TYPE = Symbol.for('IPerformanceLogger');
